<rk-modal-wrapper
  (submitted)="onSubmit()"
  (cancelled)="onAbort()"
  (closed)="onAbort()"
  [title]="'MEDIA.MODAL.ADD_PLAYLIST.TITLE' | translate"
  [submitText]="'MEDIA.MODAL.TRACK.TAG.ACTION_BUTTON' | translate"
  [loading]="isLoading$ | async"
  [isSubmitDisabled]="!addToPlaylistForm?.valid"
>
  <form [formGroup]="addToPlaylistForm" class="add-playlist-form">
    <mat-radio-group rkInput formControlName="playlistUsed">
      <div *ngIf="(playlists$ | async).length" class="existing">
        <mat-radio-button value="existing">{{
          'MEDIA.MODAL.ADD_PLAYLIST.ADD_EXISTING' | translate
        }}</mat-radio-button>
        <rk-dropdown-autocomplete
          formControlName="selectedPlaylist"
          [data]="playlists$ | async"
          [modal]="true"
          [dataIncludedForWarning]="playlistContainingTrack"
          [playlistTemplate]="true"
          [dropdownWidth]="220"
        ></rk-dropdown-autocomplete>
      </div>
      <div class="new">
        <mat-radio-button value="new">{{
          'MEDIA.MODAL.ADD_PLAYLIST.ADD_NEW' | translate
        }}</mat-radio-button>
        <ng-container *ngIf="!(playlists$ | async).length"
          ><rk-chips-input class="hidden"></rk-chips-input
        ></ng-container>
        <div class="form-input rk-input-wrapper">
          <input
            rkInput
            formControlName="playlistName"
            type="text"
            maxlength="150"
            (input)="onType()"
            [placeholder]="'MEDIA.MODAL.ADD_PLAYLIST.PLACEHOLDER' | translate"
          />
        </div>
      </div>
    </mat-radio-group>
  </form>
</rk-modal-wrapper>
